import { Injectable } from '@angular/core';
import { InspectionFactoryService } from '../../shared/services/inspectionFactory.service';
import { IndexedDbService } from '../../shared/services/indexedDb.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataService } from '../../shared/services';

@Injectable()
export class OptimisationMachineSelectorFactoryService extends InspectionFactoryService {
  constructor(indexedDb: IndexedDbService, dataService: DataService) {
    super(indexedDb, dataService);
  }

  public updateMachines(inspectionId: string, pluginId: string, machines: any[]): Observable<any> {
    if (this.isManager) {
      return this.dataService.getPlugin(inspectionId, pluginId).pipe(
        map((plugin) => {
          if (plugin) {
            plugin.config = { Machines: machines };
            return { plugin };
          }
        })
      );
    }
    return this.getInspection(inspectionId).pipe(
      map((inspection) => {
        const plugin = inspection.allPlugins.find((p) => p.id === pluginId);
        if (plugin) {
          if (inspection.data) {
            inspection.data.machine = machines;
          } else {
            inspection.data = {
              machine: machines
            };
          }
          plugin.config = { Machines: machines };
          plugin.etag = new Date();
          this.updateInspection(inspection);
          return { data: inspection.data, plugin };
        }
      })
    );
  }
}
